var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center justify-center py-10"},[_c('div',{staticClass:"w-10 h-10 text-center"},[_c('i',{staticClass:"fas fa-spinner fa-spin text-red-500 text-2xl"})]),_c('span',{staticClass:"text-sm text-gray-500 mt-2"},[_vm._v("Yükleniyor")])])
}]

export { render, staticRenderFns }